import { IMessage } from '../../Types/ConversationTypes/ConversationTypes';
import { Box } from '@mui/system';
import moment from 'moment';
import { imgUrl } from '../../Helpers/utils/Constant';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import DownloadIcon from '@mui/icons-material/Download';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

interface IProps {
  sMessage: IMessage;
}

const ShowConvMessage = ({ sMessage }: IProps) => {
  const {
    support_conversation_msg_text,
    support_conversation_msg_text_time,
    support_conversation_msg_atchments,
    support_conversation_msg_sender,
  } = sMessage;

  const isAdminMessage = support_conversation_msg_sender === 'admin';
  const getMessageClass = () =>
    isAdminMessage ? 'admin-message' : 'own-message message-box';
  const getMessageDivClass = () =>
    isAdminMessage ? 'admin-message-div' : 'own-message-div';
  const getAttachmentClass = () =>
    isAdminMessage ? 'admin-atchment' : 'own-atchment';

  const handleDownload = async (filePath: string) => {
    try {
      const response = await fetch(`${imgUrl}/${filePath}`);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filePath.split('/').pop() || 'download';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      window.open(`${imgUrl}/${filePath}`, '_blank');
    }
  };

  const renderAttachment = (attachment: string, index: number) => {
    const isPdf = attachment.toLowerCase().endsWith('.pdf');
    const fileName = attachment.split('/').pop() || 'document.pdf';

    if (isPdf) {
      return (
        <Box
          key={index}
          onClick={() => handleDownload(attachment)}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            p: 0.5,
            width: 75,
            height: 65,
            bgcolor: 'rgba(0, 0, 0, 0.05)',
            borderRadius: '6px',
            cursor: 'pointer',
            border: '1.5px solid rgba(0, 0, 0, 0.1)',
            position: 'relative',
            transition: 'all 0.2s ease',
            '&:hover': {
              bgcolor: 'rgba(0, 0, 0, 0.1)',
              borderColor: '#5e60ff',
              '& .pdf-download-btn': {
                opacity: 1,
              }
            }
          }}
        >
          <PictureAsPdfIcon sx={{ fontSize: 24, color: '#f44336', mb: 0.25 }} />
          <Typography
            variant="caption"
            sx={{
              fontSize: '8px',
              fontWeight: 600,
              color: 'text.secondary',
              width: '90%',
              textAlign: 'center',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
            title={fileName}
          >
            {fileName}
          </Typography>
          <IconButton
            className="pdf-download-btn"
            onClick={(e) => {
              e.stopPropagation();
              handleDownload(attachment);
            }}
            sx={{
              position: 'absolute',
              top: -6,
              right: -6,
              color: '#ffffff',
              backgroundColor: '#5e60ff',
              p: 0.25,
              opacity: 0,
              transition: 'opacity 0.2s ease',
              '&:hover': {
                backgroundColor: '#4042cc',
              },
              zIndex: 10,
            }}
            size="small"
          >
            <DownloadIcon sx={{ fontSize: 11 }} />
          </IconButton>
        </Box>
      );
    }

    return (
      <Box
        key={index}
        sx={{
          position: 'relative',
          width: 75,
          height: 65,
          borderRadius: '6px',
          border: '1.5px solid rgba(0, 0, 0, 0.1)',
          overflow: 'hidden',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          '&:hover .img-download-btn': {
            opacity: 1,
          }
        }}
      >
        <Zoom>
          <img
            width={75}
            height={65}
            style={{ objectFit: 'cover', borderRadius: '4px' }}
            src={`${imgUrl}/${attachment}`}
            alt=''
          />
        </Zoom>
        <IconButton
          className="img-download-btn"
          onClick={(e) => {
            e.stopPropagation();
            handleDownload(attachment);
          }}
          sx={{
            position: 'absolute',
            top: 2,
            right: 2,
            color: '#ffffff',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            p: 0.25,
            opacity: 0,
            transition: 'opacity 0.2s ease',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.75)',
            },
            zIndex: 10,
          }}
          size="small"
        >
          <DownloadIcon sx={{ fontSize: 12 }} />
        </IconButton>
      </Box>
    );
  };

  return (
    <Box className='show-message-container'>
      <Box className={getMessageClass()}>
        <Box className={getMessageDivClass()}>
          {support_conversation_msg_text && (
            <h3 style={{ wordBreak: 'break-all', whiteSpace: 'pre-line' }}>
              {support_conversation_msg_text}
            </h3>
          )}

          {support_conversation_msg_atchments.length > 0 && (
            <Box className={getAttachmentClass()}>
              {support_conversation_msg_atchments.map((attachment, index) =>
                renderAttachment(attachment, index)
              )}
            </Box>
          )}

          <p>{moment(support_conversation_msg_text_time).fromNow()}</p>
        </Box>
      </Box>
    </Box>
  );
};

export default ShowConvMessage;
